import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreConfig } from '../../../utils/config';

const BASE_URL = 'uploads';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(@Inject(CoreConfig.API_BASE_URL) public baseUrl: string, private http: HttpClient) {}

  private API_FULL_PATH: string = this.baseUrl + BASE_URL;

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.API_FULL_PATH}/in`, formData, {
      reportProgress: true,
      responseType: 'json',
    });

    return this.http.request(req);
  }
/*
  getFiles(): Observable<any> {
    return this.http.get(`${this.API_FULL_PATH}/files`);
  }*/

  visitsUpload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.API_FULL_PATH}/visits`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  tankCleanningUpload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.API_FULL_PATH}/tankCleanning`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  getFiles(param?): Observable<any> {
    if (param){
      return this.http.get(`${this.API_FULL_PATH}/visitsFiles`);
    }else{
      return this.http.get(`${this.API_FULL_PATH}/files`);
    }
    
  }
  getFile(param?): Observable<any> {
    if (param){
      return this.http.post(`${this.API_FULL_PATH}/file`,{id: param.id, from: param.from});
    }else{
      return this.http.get(`${this.API_FULL_PATH}/files`);
    }
    
  }
}
